import React, { useState } from 'react';
import GenericTable from 'shared/components/common/table/table';
import styles from './style.module.scss';
import { DelIcon, EditIcon, PlusIcon, ProjectNameIcon, StatusCheckIcon } from 'assets';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import Heading from 'shared/components/common/heading/Heading';
import Switch2 from 'shared/components/common/switch2/Switch2';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import DeleteConfirmation from 'shared/modal/delete_confirmation/DeleteConfirmation';

const InnerPoTable = ({ PoList, OffPage, setIsEdit, handleDelete }) => {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);

    const [selectDelUser, setSelectDelUser] = useState(null);
    const [openDelConfirm, setOpenDelConfirm] = useState(false);

    const closeDelConfirmation = () => setOpenDelConfirm(false);

    const confirmDelete = () => {
        if (selectDelUser !== null) {
            handleDelete(selectDelUser);  // Call parent delete handler
            closeDelConfirmation();
        }
    };

    const subTotal = PoList?.reduce((sum, item) => {
        const total = (item.price || 0) * (item.quantity || 0);
        return sum + total;
    }, 0);

 const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num)) return 'Rs 0.00';
        return `Rs ${num.toFixed(2)}`;
    };

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Compatible Brand
                    </div>
                ),
                accessor: 'Compatible',
                Cell: ({ row }) => <div>{row.original?.competebleBrand?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Model
                    </div>
                ),
                accessor: 'as',
                Cell: ({ row }) => <div>{row.original?.product?.name}</div>
            },

            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Sub Categ.
                    </div>
                ),
                accessor: 'subCategory',
                Cell: ({ row }) => <div>{row.original?.sub_category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Product Category
                    </div>
                ),
                accessor: 'categorys',
                Cell: ({ row }) => <div>{row.original?.product_category?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Brand
                    </div>
                ),
                accessor: 'brands',
                Cell: ({ row }) => <div>{row.original.brand?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Color
                    </div>
                ),
                accessor: 'color',
                Cell: ({ row }) => <div>{row.original.color}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Quantity
                    </div>
                ),
                accessor: 'quantity',
                Cell: ({ row }) => <div>{(row.original.quantity)}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Price
                    </div>
                ),
                accessor: 'price',
                Cell: ({ row }) => <div>{formatPrice(row.original.price)}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Total
                    </div>
                ),
                accessor: 'total',
                Cell: ({ row }) => <div>{formatPrice(row.original.price * row.original.quantity)}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Action
                    </div>
                ),
                accessor: 'status',
                Cell: ({ row }) => (
                    <div className={classNames(styles.Statuses)}>
                        <DelIcon
                            className="pointer"
                            onClick={() => {
                                if (isRestrictActions(screenEnum.po, screenActionEnum.delete)) {
                                    setOpenDelConfirm(true);
                                    setSelectDelUser(row.index);
                                }
                            }}
                        />

                    </div>
                )
            }
        ],

        [theme]
    );
    return (
        <div className={'text-start'}>
            <div className={styles.Header}>
                <Heading heading={'Purchase Order'} headingStyle={styles.Heading} />
            </div>
            <GenericTable columns={columns} innerpo={'innerpoOn'} OffPage={OffPage} data={PoList || []} TableWrapperStyle={classNames(styles.Table)} />
            <div className={styles.TableFooter}>
                <div className={styles.SubtotalRow}>
                    <strong>Subtotal:</strong> {subTotal.toLocaleString()}
                </div>
            </div>

            <DeleteConfirmation
                show={openDelConfirm}
                handleClose={closeDelConfirmation}
                DeleteHandler={() => {
                    confirmDelete();
                }}
                ConfimationHeading="Delete Item"
                Desc={'Are you sure you want to delete the Item?'} />

        </div>
    );
};
export default InnerPoTable;
